if (!customElements.get('product-media')) {
  customElements.define(
    'product-media',
    class ProductMedia extends HTMLElement {
      constructor() {
        super()
        this.blazeSlider = null
      }

      connectedCallback() {
        this.initSlider()
      }

      disconnectedCallback() {
        if (this.blazeSlider) {
          this.blazeSlider.destroy()
          this.blazeSlider = null
        }
      }

      initSlider() {
        const sliderElement = this.querySelector('.blaze-slider')
        if (!sliderElement) return

        const slides = sliderElement.querySelectorAll('.blaze-slide')
        if (slides.length <= 1) {
          this.querySelector('.js-media-pagination')?.classList.add('hidden')
          return
        }

        if (typeof window.BlazeSlider === 'undefined') {
          const script = document.querySelector('script[src*="blaze-slider"]')
          if (script) {
            script.addEventListener('load', () => this.initSlider(), { once: true })
          }
          return
        }

        const self = this

        try {
          this.blazeSlider = new window.BlazeSlider(sliderElement, {
            all: {
              enableAutoplay: false,
              enablePagination: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              transitionDuration: 300,
              transitionTimingFunction: 'ease-in-out',
              loop: false,
              draggable: true,
              slideGap: '0px',
              onSlide(stateIndex) {
                self.onSlideChange(stateIndex)
              },
            },
          })

          this.setupThumbnails()
          this.setupNavigation()

          // Sync initial state — ensure slide 0 is active
          this.updateActiveThumbnail(0)
          this.syncNavigationState()
        } catch (error) {
          console.error('product-media: Error initializing BlazeSlider:', error)
        }
      }

      onSlideChange(stateIndex) {
        this.updateActiveThumbnail(stateIndex)
        this.scrollActiveThumbnailIntoView(stateIndex)
        this.syncNavigationState()
        this.handleDeferredMedia(stateIndex)
      }

      setupThumbnails() {
        this.thumbnails = this.querySelectorAll('.js-thumbnail-item')
        this.thumbnails.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const index = parseInt(thumb.dataset.index, 10)
            this.goToSlide(index)
          })
          thumb.addEventListener('keydown', (e) => {
            if (e.key !== 'Enter' && e.key !== ' ') return
            e.preventDefault()
            const index = parseInt(thumb.dataset.index, 10)
            this.goToSlide(index)
          })
        })
      }

      goToSlide(index) {
        if (!this.blazeSlider) return
        const current = this.blazeSlider.stateIndex
        const diff = index - current
        if (diff === 0) return
        if (diff > 0) {
          this.blazeSlider.next(diff)
        } else {
          this.blazeSlider.prev(Math.abs(diff))
        }
      }

      updateActiveThumbnail(index) {
        this.thumbnails?.forEach((thumb) => {
          thumb.classList.toggle(
            'is-active',
            parseInt(thumb.dataset.index, 10) === index
          )
        })
      }

      handleDeferredMedia(activeIndex) {
        const slides = this.querySelectorAll('.blaze-slide')
        slides.forEach((slide, i) => {
          slide.querySelectorAll('deferred-media').forEach((el) => {
            if (typeof el.togglePlayer !== 'function') return
            if (i === activeIndex) {
              el.togglePlayer(false, false)
            } else {
              el.togglePlayer(true)
            }
          })
        })
      }

      setupNavigation() {
        const track = this.querySelector('.product-media-thumbnails__track')
        if (!track) return

        this.thumbTrack = track
        this.thumbScrollAmount = 55 // 45px thumb + 10px gap

        this.querySelectorAll('.js-slide-arrow').forEach((button) => {
          button.addEventListener('click', (event) => {
            const direction = event.currentTarget.getAttribute('data-direction')
            if (direction === 'prev') {
              track.scrollBy({ left: -this.thumbScrollAmount * 6, behavior: 'smooth' })
            } else {
              track.scrollBy({ left: this.thumbScrollAmount * 6, behavior: 'smooth' })
            }
            setTimeout(() => this.syncNavigationState(), 350)
          })
        })
      }

      scrollActiveThumbnailIntoView(index) {
        const thumb = this.thumbnails?.[index]
        if (thumb && this.thumbTrack) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
        }
      }

      isAtStart() {
        if (!this.thumbTrack) return true
        return this.thumbTrack.scrollLeft <= 0
      }

      isAtEnd() {
        if (!this.thumbTrack) return true
        return this.thumbTrack.scrollLeft + this.thumbTrack.clientWidth >= this.thumbTrack.scrollWidth - 1
      }

      syncNavigationState() {
        const atStart = this.isAtStart()
        const atEnd = this.isAtEnd()
        this.querySelectorAll('.js-slide-arrow').forEach((button) => {
          const direction = button.getAttribute('data-direction')
          if (direction === 'prev' && atStart) {
            button.setAttribute('disabled', 'true')
          } else if (direction === 'next' && atEnd) {
            button.setAttribute('disabled', 'true')
          } else {
            button.removeAttribute('disabled')
          }
        })
      }
    }
  )
}
